import React from 'react';
import PropTypes from 'prop-types';
import './TextInput.css';

/**
 * TextInput - Standardized text input component
 * Supports text, email, password, number, etc.
 */
const TextInput = ({
  id,
  name,
  type = 'text',
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  autoComplete,
  min,
  max,
  step,
  pattern,
  className = '',
  size = 'md',
  prefix,
  suffix,
}) => {
  return (
    <div className={`ml-text-input ml-text-input--${size} ${className}`}>
      {prefix && <span className="ml-text-input__prefix">{prefix}</span>}
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
        min={min}
        max={max}
        step={step}
        pattern={pattern}
        className="ml-text-input__control"
      />
      {suffix && <span className="ml-text-input__suffix">{suffix}</span>}
    </div>
  );
};

TextInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(['text', 'email', 'password', 'number', 'tel', 'url', 'search']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  autoComplete: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pattern: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  prefix: PropTypes.node,
  suffix: PropTypes.node,
};

export default TextInput;
